import { Reveal } from "@/components/motion/Reveal";

const LOGOS = [
  { name: "Reuters", src: "/logos/reuters.png", h: 22 },
  { name: "Massive", src: "/logos/massive.png", h: 30 },
  { name: "Polygon", src: "/logos/polygon.png", h: 26 },
  { name: "Databento", src: "/logos/databento.png", h: 22 },
  { name: "Bloomberg", src: "/logos/bloomberg.png", h: 22 },
];

export const Marquee = () => (
  <section className="relative py-10 lg:py-12" aria-label="Data and news sources" data-testid="source-logos">
    <div className="container-x">
      <Reveal>
        <p className="text-center font-mono text-[10px] tracking-[0.04em] text-[var(--ink-4)]">Market data &amp; news sourced from</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-14 gap-y-8 lg:gap-x-20">
          {LOGOS.map((l) => (
            <img
              key={l.name}
              src={l.src}
              alt={l.name}
              style={{ height: l.h }}
              className="w-auto opacity-70 grayscale transition-opacity duration-300 hover:opacity-100 select-none"
              draggable={false}
              data-testid={`source-logo-${l.name.toLowerCase()}`}
            />
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
